import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 6A3136A3-62AD-4DE6-A783-D9D69AAD8919
 * name micro-sd
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/micro-sd.svg
 * tags
 */
export const MicroSdIcon = createSvgIcon(<><path d="M8,2A2,2 0 0,0 6,4V11L4,13V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V4A2,2 0 0,0 18,2H8M9,4H11V8H9V4M12,4H14V8H12V4M15,4H17V8H15V4Z" /></>, 'MicroSdIcon');
export default MicroSdIcon